import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const SMS_CampusLifePhotos = () => {
  const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.campusLifePhotos, setData);
  }, [currentDomain]);

  const galleryData = data?.data?.attributes?.photos || [];
  const pageTitle = data?.data?.attributes?.title || "Campus Life Photos";

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Campus Life Photos | SMS | JNTU Anantapur</title>
        <meta
          name="description"
          content="Campus Life Photos of School of Management Studies, JNTUA - Events, Campus, and Activities"
        />
        <meta
          name="keywords"
          content="Campus Life, Photos, Gallery, Events, SMS, School of Management Studies, JNTUA"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .gallery-section {
                        margin-bottom: 50px;
                    }

                    .gallery-section-title {
                        color: #007bff;
                        font-weight: 700;
                        margin-bottom: 25px;
                        padding-bottom: 15px;
                        border-bottom: 3px solid #007bff;
                        font-size: calc(${fontSize}px + 6px);
                        position: relative;
                    }

                    .gallery-section-title::after {
                        content: '';
                        position: absolute;
                        bottom: -3px;
                        left: 0;
                        width: 100px;
                        height: 3px;
                        background: #0056b3;
                    }

                    .gallery-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                        gap: 25px;
                        margin-top: 30px;
                    }

                    .gallery-item {
                        position: relative;
                        overflow: hidden;
                        border-radius: 12px;
                        box-shadow: 0 4px 15px rgba(0,123,255,0.1);
                        transition: all 0.4s ease;
                        cursor: pointer;
                        background: #fff;
                    }

                    .gallery-item:hover {
                        transform: translateY(-8px);
                        box-shadow: 0 8px 25px rgba(0,123,255,0.25);
                    }

                    .gallery-item::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(135deg, rgba(0,123,255,0.8) 0%, rgba(0,86,179,0.8) 100%);
                        opacity: 0;
                        transition: opacity 0.3s ease;
                        z-index: 1;
                    }

                    .gallery-item:hover::before {
                        opacity: 1;
                    }

                    .gallery-item img {
                        width: 100%;
                        height: 250px;
                        object-fit: cover;
                        display: block;
                        transition: transform 0.4s ease;
                    }

                    .gallery-item:hover img {
                        transform: scale(1.1);
                    }

                    .gallery-item-overlay {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        opacity: 0;
                        transition: opacity 0.3s ease;
                        z-index: 2;
                        text-align: center;
                    }

                    .gallery-item:hover .gallery-item-overlay {
                        opacity: 1;
                    }

                    .gallery-item-overlay i {
                        font-size: 48px;
                        color: white;
                        margin-bottom: 10px;
                        display: block;
                    }

                    .gallery-item-overlay span {
                        color: white;
                        font-size: 14px;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 1px;
                    }

                    .gallery-caption {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
                        color: white;
                        padding: 15px;
                        font-size: calc(${fontSize}px - 1px);
                        opacity: 0;
                        transition: opacity 0.3s ease;
                        z-index: 2;
                    }

                    .gallery-item:hover .gallery-caption {
                        opacity: 1;
                    }

                    .modal {
                        display: none;
                        position: fixed;
                        z-index: 9999;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.95);
                        animation: fadeIn 0.3s ease;
                    }

                    .modal.active {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .modal-content {
                        max-width: 90%;
                        max-height: 90%;
                        animation: zoomIn 0.3s ease;
                    }

                    .modal-content img {
                        width: 100%;
                        height: auto;
                        border-radius: 8px;
                        box-shadow: 0 10px 50px rgba(0,123,255,0.5);
                    }

                    .modal-close {
                        position: absolute;
                        top: 30px;
                        right: 50px;
                        color: white;
                        font-size: 48px;
                        font-weight: bold;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        z-index: 10000;
                    }

                    .modal-close:hover {
                        color: #007bff;
                        transform: rotate(90deg);
                    }

                    .no-gallery-data {
                        text-align: center;
                        padding: 80px 20px;
                        color: #999;
                    }

                    .no-gallery-data i {
                        font-size: 80px;
                        color: #ddd;
                        margin-bottom: 25px;
                        display: block;
                    }

                    .no-gallery-data h5 {
                        color: #666;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }

                    @keyframes zoomIn {
                        from { 
                            opacity: 0;
                            transform: scale(0.5);
                        }
                        to { 
                            opacity: 1;
                            transform: scale(1);
                        }
                    }

                    @media (max-width: 768px) {
                        .gallery-grid {
                            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                            gap: 15px;
                        }

                        .gallery-item img {
                            height: 200px;
                        }

                        .modal-close {
                            top: 15px;
                            right: 15px;
                            font-size: 36px;
                        }

                        .modal-content {
                            max-width: 95%;
                            max-height: 85%;
                        }
                    }
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Campus Life Photos"
          pageName="Campus Life Photos"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title text-center mb-5">
                      {pageTitle}
                    </h3>
                    
                    {galleryData.length > 0 ? (
                      <div className="gallery-section">
                        <div className="gallery-grid">
                          {galleryData.map((photoItem, index) => {
                            const imageData = photoItem?.image?.data?.attributes;
                            const imageUrl = imageData?.url;
                            const thumbnailUrl = imageData?.formats?.small?.url || imageData?.formats?.thumbnail?.url || imageUrl;
                            const altText = photoItem?.alt_text || imageData?.alternativeText || `Campus Life Image ${index + 1}`;
                            const caption = photoItem?.caption;
                            
                            return imageUrl ? (
                              <div 
                                key={photoItem.id || index} 
                                className="gallery-item"
                                onClick={() => openModal(imageBaseURL + imageUrl)}
                              >
                                <img 
                                  src={imageBaseURL + thumbnailUrl} 
                                  alt={altText}
                                  loading="lazy"
                                />
                                <div className="gallery-item-overlay">
                                  <i className="fa fa-search-plus"></i>
                                  <span>View Image</span>
                                </div>
                                {caption && (
                                  <div className="gallery-caption">
                                    {caption}
                                  </div>
                                )}
                              </div>
                            ) : null;
                          })}
                        </div>
                      </div>
                    ) : (
                      <div className="no-gallery-data">
                        <i className="fas fa-images"></i>
                        <h5>No campus life photos available at the moment.</h5>
                        <p>Please check back later for photo updates.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <div className={`modal ${selectedImage ? 'active' : ''}`} onClick={closeModal}>
        <span className="modal-close" onClick={closeModal}>&times;</span>
        {selectedImage && (
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full view" />
          </div>
        )}
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMS_CampusLifePhotos;
